import { render, staticRenderFns } from "./CreateAndUpdate.vue?vue&type=template&id=0a1b19b7&scoped=true"
import script from "./CreateAndUpdate.vue?vue&type=script&lang=js"
export * from "./CreateAndUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a1b19b7",
  null
  
)

export default component.exports